var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcDelSurvey = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#3D4043",
  fillRule: "evenodd",
  d: "M0 3.504a.7.7 0 0 1 .7-.7h12.6a.7.7 0 1 1 0 1.4H.7a.7.7 0 0 1-.7-.7",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#3D4043",
  fillRule: "evenodd",
  d: "M5.599 1.4a.7.7 0 0 0-.7.7v.7h4.2v-.7a.7.7 0 0 0-.7-.7zm4.9 1.4v-.7a2.1 2.1 0 0 0-2.1-2.1h-2.8a2.1 2.1 0 0 0-2.1 2.1v.7h-1.4a.7.7 0 0 0-.7.7v9.8a2.1 2.1 0 0 0 2.1 2.1h7a2.1 2.1 0 0 0 2.1-2.1V3.5a.7.7 0 0 0-.7-.7zm-7.7 1.4v9.1a.7.7 0 0 0 .7.7h7a.7.7 0 0 0 .7-.7V4.2z",
  clipRule: "evenodd"
})));
export default SvgIcDelSurvey;